import React from "react";
import Slider from "react-slick";
import moment from "moment-timezone";

const FilmDetail = (props) => {
  const settings = {
    customPaging: i => {
      return <a>{i + 1}</a>;
    },
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  return (
    <React.Fragment>
      {props.filmType === "Film" || props.filmType === "BeyondFilm" || props.filmType === "PartnerEvent" ?
      <div className="screening_top d_flex">
        <div className="d_flex">
          <div className="left_col">
            <Slider {...settings}>
              {props.film.images && props.film.images.map((image) => {
                return (
                  <div>
                    <div className="media_image">
                      <img src={   
                        image.inSite ? props.imageUrl + image.inSite : 
                          image.link ? image.link : 
                         '/images/image-placeholder.png'} alt="image" />
                    </div>
                  </div>
                );
              })}
            </Slider>
          </div>

        </div>
        <div className="screening_movie_desc screening_movie_sec">
          <div className="movie_category">
            <div>
              {props.film.category && <p className="mt_10">{props.film.category && props.film.category.name}</p>}
              <h3 className="feature_title">{props.film.title}</h3>
              <p className="editor_view" dangerouslySetInnerHTML={{ __html: props.film.description }} />
              <div className="data_list">
                <ul>
                  {props.film.year && <li className="d_flex">
                    <label>Year</label>
                    <span> {props.film.year}</span>
                  </li>}
                  {props.film.category && <li className="d_flex">
                    <label>Category</label>
                    <span> {props.film.category && props.film.category.displayName}</span>
                  </li>}
                  {props.film.country && <li className="d_flex">
                    <label>Country</label>
                    <span> {props.film.country}</span>
                  </li>}
                  {props.film.runTime && <li className="d_flex">
                    <label>Run Time</label>
                    <span> {props.film.runTime}</span>
                  </li>}
                  {props.film.company && <li className="d_flex">
                    <label>Company</label>
                    <span> {props.film.company}</span>
                  </li>}
                  {props.film.website && <li className="d_flex">
                    <label>Website</label>
                    <span> {props.film.website}</span>
                  </li>}
                  {props.film.contact && <li className="d_flex">
                    <label>Contact</label>
                    <span>{props.film.contact && props.film.contact.map((item) => <p>{item && item.emailPhone}</p>)}</span>
                  </li>}
                  {props.film.genre && <li className="d_flex">
                    <label>Genre</label>
                    <span>{props.film.genre && props.film.genre.map((item) => <p>{item.name}</p>)}
											  </span>
                  </li>}
                  {props.film.interestTrack && <li className="d_flex">
                    <label>Interest Tracks</label>
                    <span>{props.film.interestTrack && props.film.interestTrack.map((item) => (
                      <p>{item.name}</p>
                    ))}
											</span>
                  </li>}
                  {props.film.accessibility && <li className="d_flex">
                    <label>Accessibility</label>
                    <span>{props.film.accessibility && props.film.accessibility.map((item) => (
                      <p>{item.name}</p>
                    ))}
											</span>
                  </li>}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="screening_dates_side">
          <p
            className="text_right mb_10">{moment(props.film.filmDate || props.film.eventDate).tz("US/Mountain").format("ddd")}, {moment(props.film.filmDate || props.film.eventDate).tz("US/Mountain").format("MMM DD")} - {moment(props.film.filmDate || props.film.eventDate).tz("US/Mountain").format("h:mm A")}</p>
          <div className="screen_dates">
            <div className="header_title">
              <h3>Screening Date - Time (MT)</h3>
            </div>
            {console.log(props.film,"props.film")}
            <div className="screen_list">
              <ul>
                <li>
                  <p>{moment(props.film.filmDate || props.film.eventDate).tz("US/Mountain").format("dddd")}, {moment(props.film.filmDate || props.film.eventDate).tz("US/Mountain").format("MMM DD")} - {moment(props.film.filmDate || props.film.eventDate).tz("US/Mountain").format("h:mm A")}</p>
                </li>
              </ul>
            </div>
            <div className="text_right participate_row">
              <h4>Current active participants</h4>
              <h2>{props.userCount}</h2>
            </div>
          </div>
        </div>
      </div>
      :
      <div className="screening_top d_flex">
            <div className="d_flex">
          <div className="left_col">
                  <div>
                    <div className="media_image">
                      <img src={   
                        props.film.sponsorLogo === '' ? '/images/image-placeholder.png' :  props.imageUrl + props.film.sponsorLogo } alt="image" />
                    </div>
                  </div>
          </div>
        </div>

        <div className="screening_movie_desc screening_movie_sec">
          <div className="movie_category">
            {/* <div>
              <h3 className="feature_title">{props.film.name}</h3> */}
              {/* <div className="data_list">
                <ul>
                {props.film.shift72Id && <li className="d_flex">
                    <label>Shift72 Id</label>
                    <span> {props.film.shift72Id}</span>
                  </li>}
                </ul>
              </div> */}

              <div className="program_left mt_0">
                  <div className="program_title_input d_flex d_flex_justify_spacebt mb_10 d_flex_align_center">
                      <h3>{props.film && props.film.name}</h3>
                      <span className="id_text"><label>Access: </label> {props.film && props.film.access && props.film.access.name}</span>
                  </div>
                  <div className="program_header d_flex">
                      <h3>Shorts Included in Program</h3>
                  </div>
                  <div className="program_inner">
                      <ul>
                      { props?.film?.shortProgrammeFilms && props.film.shortProgrammeFilms.map((item)=>{
                                  return(
                          <li>
                              <div className="d_flex list_inner d_flex_align_center">
                                  
                                  <div className="program_contents d_flex">
                                      <div className="program_image">
                                          <img src={ 
                                              item?.film?.images?.inSite ? props.imageUrl + item.film.images.inSite :
                                              item?.film?.images?.link ? item?.film?.images?.link :
                                            '/images/image-placeholder.png'} />
                                      </div>
                                      <div className="program_contents_desc">
                                          <h2 className="program_title">{item && item.film && item.film.title}</h2>
                                          <p className="program_time">{item && item.film && item.film.runTime} min</p>
                                      </div>
                                  </div>

                                  
                                                                                  
                              </div>
                          </li>
                            )
                          })}
                      </ul>
                  </div>
              {/* </div> */}
            </div>
          </div>
        </div>
          <div className="screening_dates_side">
          <p
            className="text_right mb_10">{moment(props.film.date).tz("US/Mountain").format("ddd")}, {moment(props.film.date).tz("US/Mountain").format("MMM DD")} - {moment(props.film.date).tz("US/Mountain").format("h:mm A")}</p>
          <div className="screen_dates">
            <div className="header_title">
              <h3>Screening Date - Time (MT)</h3>
            </div>
            <div className="screen_list">
              <ul>
                <li>
                  <p>{moment(props.film.date).tz("US/Mountain").format("dddd")}, {moment(props.film.date).tz("US/Mountain").format("MMM DD")} - {moment(props.film.date).tz("US/Mountain").format("h:mm A")}</p>
                </li>
              </ul>
            </div>
            <div className="text_right participate_row">
              <h4>Current active participants</h4>
              <h2>{props.userCount}</h2>
            </div>
          </div>
        </div>
      </div>
    }
   </React.Fragment>
  );
};

FilmDetail.propTypes = {};

export default FilmDetail;